import React from "react";
import RichText from "components/rich-text";

import "./index.scss";

const FullpageRichText = ({ data }) => {
  const components = {
    normal: ({ children }) => (
      <p className="paragraph-lg-normal text-gray-700 sm:text-base mt-5">
        {children}
      </p>
    ),
    h1: ({ children }) => (
      <h1 className="header mt-7 mb-8 sm:text-2xl">{children}</h1>
    ),
    h2: ({ children }) => (
      <h2 className="text-h2 mt-7 mb-8 sm:text-xl">{children}</h2>
    ),
    h3: ({ children }) => (
      <h3 className="text-h3 font-bold mt-11 mb-8 sm:text-xl text-gray-800">
        {children}
      </h3>
    ),
  };

  const moreOptions = {
    list: {
      bullet: (child) => {
        return <ul className="list-disc pl-5 mt-5">{child.children}</ul>;
      },
      number: ({ children }) => (
        <ol className="list-disc pl-5 mt-5">{children}</ol>
      ),
    },
    listItem: {
      bullet: ({ children, value: { style } }) => (
        <li>
          {style == "normal" ? (
            <p className="paragraph-lg-normal text-gray-700 sm:text-base">
              {children}
            </p>
          ) : (
            children
          )}
        </li>
      ),
      bullet: ({ children, value: { style } }) => (
        <li>
          {style == "normal" ? (
            <p className="paragraph-lg-normal text-gray-700 sm:text-base">
              {children}
            </p>
          ) : (
            children
          )}
        </li>
      ),
    },
  };

  return (
    <div className="container fullpageRichtext">
      <RichText
        value={data.content.data}
        components={components}
        moreOptions={moreOptions}
      />
    </div>
  );
};

export default FullpageRichText;
